module.exports = __webpack_public_path__ + "static/media/datBim.d49e1df2.png";